import { render } from "./ChatImageViewer.vue?vue&type=template&id=78060cbc&scoped=true"
import script from "./ChatImageViewer.vue?vue&type=script&lang=js"
export * from "./ChatImageViewer.vue?vue&type=script&lang=js"

import "./ChatImageViewer.vue?vue&type=style&index=0&id=78060cbc&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78060cbc"]])

export default __exports__